module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-light-8e5dbfbcfa3ce39a125005407b2ac7d0.png";